import React from "react";
import ContactForm from "./ContactForm";

const Contact = () => {
  return (
    <div id="contact" className="bg-gray-50 lg:py-20  py-10  px-8 lg:px-36">
      <h2 className="block lg:hidden md:hidden text-center mb-5 lg:text-5xl text-4xl pt-5 font-[500]">
        Contact
      </h2>
      <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 lg:gap-14 md:gap-10">
        <div className="lg:order-1 md:order-1 order-2 lg:mt-3.5 mt-8 mb-4 px-1">
          <h3 className="lg:text-5xl text-3xl mb-4 font-[500] lg:mb-5 pt-5 lg:pt-0">
            Let's Get in touch
          </h3>
          <p className="text-lg leading-loose lg:text-left text-justify">
            I enjoy discussing new projects and design challenges. If you want
            to work with me feel free to contact with me. I will response as
            soon as possible.
          </p>
          <h4 className="lg:mt-6 mt-4 text-lg font-[500]">Phone:</h4>
          <p>
            <a href="tel:+8801521566317">+8801521566317</a>
          </p>
          <h4 className="lg:mt-6 mt-4 text-lg font-[500]">Email:</h4>
          <p>
            <a
              href="mailto:muntasir01521566317@gmail.com"
              rel="noreferrer"
              target="_blank"
            >
              muntasir01521566317@gmail.com
            </a>
            .
          </p>
        </div>
        <div className="lg:order-2 md:order-2 order-1 lg:mt-3 md:mt-14">
          <ContactForm></ContactForm>
        </div>
      </div>
    </div>
  );
};

export default Contact;
